import { render, staticRenderFns } from "./KoAnniversary.vue?vue&type=template&id=e80ac21e&scoped=true"
import script from "./KoAnniversary.vue?vue&type=script&lang=js"
export * from "./KoAnniversary.vue?vue&type=script&lang=js"
import style0 from "./KoAnniversary.vue?vue&type=style&index=0&id=e80ac21e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80ac21e",
  null
  
)

export default component.exports